import { render, staticRenderFns } from "./CombChickenlegsCintillos.vue?vue&type=template&id=3d4badda"
import script from "./CombChickenlegsCintillos.vue?vue&type=script&lang=js"
export * from "./CombChickenlegsCintillos.vue?vue&type=script&lang=js"
import style0 from "./CombChickenlegsCintillos.vue?vue&type=style&index=0&id=3d4badda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports